import ModalController from '../assets/js/controllers/modal';

import { classesActiveAndIn, classesDelayedOut, multiAddEventListener, multiRemoveEventListener, validateParamBoolean } from '../assets/js/helpers';

// constants
import ModalEvent from './modal-event';

export default class Modal {

	static selector = 'modal';

	// class variables

	config = {
		id: null,
		isCustomFormActions: true
	};

	el = {};

	flags = {
		isOpen: false
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctasClose: container.querySelectorAll('[data-modal-cta-close]')
		};

		this.config.id = container.getAttribute('id');
		this.config.isCustomFormActions = validateParamBoolean(this.el.container, 'data-custom-form-actions');
	}

	// initialize

	initialize() {

	}

	// listeners that will always be active

	#addEventListeners = () => {
		multiAddEventListener(this.el.ctasClose, 'click', this.#onCtaCloseClick);
		if (!this.config.isCustomFormActions) {
			document.body.addEventListener('hsvalidatedsubmit', this.#onFormSubmit);
		}
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.ctasClose, 'click', this.#onCtaCloseClick);
		document.body.addEventListener('hsvalidatedsubmit', this.#onFormSubmit);
	}

	// listener methods

	#onCtaCloseClick = () => {
		ModalController.close();
	}

	#onFormSubmit = (e) => {
		for (let i = 0; i < e.path.length; i++) {
			const $pathItem = e.path[i];
			if ($pathItem instanceof Element && this.el.container.contains($pathItem)) {
				ModalController.close();
				break;
			}
		}
	}

	//

	open() {
		if (!this.flags.isOpen) {
			this.flags.isOpen = true;
			this.el.container.classList.add('is-active');
			classesActiveAndIn(this.el.container);
			this.el.container.dispatchEvent(new Event(ModalEvent.OPEN));
			this.#addEventListeners();
		}
	}

	close() {
		if (this.flags.isOpen) {
			this.flags.isOpen = false;
			classesDelayedOut(this.el.container, 300);
			this.el.container.dispatchEvent(new Event(ModalEvent.CLOSE));
			this.#removeEventListeners();
		}
	}

	// destroy

	destroy() {
		classesDelayedOut(this.el.container, 0);
		this.#removeEventListeners();
	}

	// getters

	get id() {
		return this.config.id;
	}

}
